import PropTypes from "prop-types";
import React from "react";
import { Button, Table } from "semantic-ui-react";
import { prettyDate } from "../../../../../../services/DateTime";
import { PrettyCurrency } from "../../../../../../services/PrettyNumber";
import UuidLookups from "../../../../../../components/UuidLookups";

export const columns = [
  {
    key: "disbursement_date",
    name: "Deposit Date"
  },
  {
    key: "reason_deposits",
    name: "Reason"
  },
  {
    key: "amount",
    name: "Amount"
  },
  {
    key: "created_by",
    name: "Created By"
  },
  {
    key: "created_datetime",
    name: "Created Date"
  },

  {
    key: "editDeleteGlyphs",
    name: ""
  }
];

function DepositsTable({ docs, onEdit }) {
  const totalAmount = docs.reduce((n, { amount }) => n + amount || 0, 0);
  const truncateReason = input =>
    input.length > 25 ? `${input.substring(0, 25)}...` : input;

  return (
    <div>
      <Table size="small" textAlign="left">
        <Table.Header>
          <Table.Row>
            {columns.map(column => (
              <Table.HeaderCell key={column.key}>
                {column.name}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {docs.map(doc => (
            <Table.Row key={doc.uuid}>
              <Table.Cell>{doc[columns[0].key]}</Table.Cell>
              <Table.Cell>
                {doc[columns[1].key] === "Other"
                  ? `Other: ${truncateReason(doc.reason_other)}`
                  : doc[columns[1].key]}
              </Table.Cell>
              <Table.Cell>
                {PrettyCurrency(parseFloat(doc[columns[2].key]) || 0, false)}
              </Table.Cell>
              <Table.Cell>
                <UuidLookups lookupType="user" uuid={doc[columns[3].key]} />
              </Table.Cell>
              <Table.Cell>
                {prettyDate(doc[columns[4].key], true) || "--"}
              </Table.Cell>
              <Table.Cell textAlign="right">
                <Button
                  basic
                  circular
                  color="green"
                  icon="edit"
                  data-testid="deposit-edit-btn"
                  onClick={() => onEdit(doc)}
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell>
              <h5 data-testid="total-deposit-amount">
                Total deposits:
                {"  "}
                {PrettyCurrency(parseFloat(totalAmount) || 0, false)}
              </h5>
            </Table.HeaderCell>
            <Table.HeaderCell colSpan="5" />
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
}

DepositsTable.propTypes = {
  docs: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEdit: PropTypes.func
};

export default DepositsTable;
